<template>
  <div class="bg">
    <div class="page-bg"></div>
    <mu-container class="wrap" @click="switchContentAll()">
      <h3 class="title">课程简介</h3>
      <div
        ref="content"
        :class="{ 'content-all': contentAll, content: isOverLimit }"
        class=""
      >
        {{ data.remark }}
      </div>

      <div v-if="isOverLimit" class="loader-more-wrapper">
        <mu-button icon small color="#9e9e9e">
          <mu-icon
            :value="contentAll ? 'arrow_drop_up' : 'arrow_drop_down'"
          ></mu-icon>
        </mu-button>
      </div>
    </mu-container>

    <mu-list class="list animated slideInUp">
      <!-- <mu-list-item
        v-if="type === 2"
        :ripple="false"
        :to="{
          path: getPath,
          query: {
            subject_id: $route.query.subject_id,
            checkbox: 1,
          },
        }"
        class="item"
        button
      >
        <mu-list-item-title>
          多选题
        </mu-list-item-title>

        <mu-list-item-action>
          <mu-icon value="chevron_right"></mu-icon>
        </mu-list-item-action>
      </mu-list-item> -->

      <mu-list-item
        v-for="item in data.chapter_lists"
        :key="item.id"
        :ripple="false"
        :to="{
          path: getPath,
          query: {
            chapter_id: item.id,
            is_visible: $route.query.is_visible,
            allow_practise: $route.query.allow_practise,
            is_record: $route.query.is_record,
          },
        }"
        class="item"
        button
      >
        <mu-list-item-title>
          {{ item.title }}
        </mu-list-item-title>

        <mu-list-item-action>
          <div
            v-if="$route.query.is_record === 'record'"
            :class="{
              finish: item.percent >= 1,
            }"
          >
            {{ item.percent_num_text }}
          </div>
          <mu-icon v-else value="chevron_right"></mu-icon>
        </mu-list-item-action>
      </mu-list-item>
    </mu-list>

    <mu-button
      v-show="type === 1 && Number($route.query.is_visible) === 0"
      color="#214ecf"
      style="position: fixed; right: 10px; bottom: 90px;"
      small
      fab
      @click="goBuy"
    >
      购买
    </mu-button>
  </div>
</template>

<script>
import { fetchCourseChapterLists } from '@/api/index'

export default {
  components: {},
  data() {
    return {
      type: 1,
      isOverLimit: false,
      contentAll: false,
      data: {},
      info: {
        name: null,
        path: null,
      },
      breadcrumbsArr: [],
    }
  },

  beforeRouteUpdate() {
    console.log('beforeRouteUpdate')
    this.init()
  },

  computed: {
    getPath() {
      let path = ''
      switch (this.type) {
        case 1:
          path = '/online-course'
          break
        case 2:
          path = '/module-exam'
          break
      }
      if (path === '') {
        console.error(
          "CourseChapterLists.vue methods.init()::'path' is empty string"
        )
      }
      return path
    },
  },

  mounted() {
    // this.type = this.$root.$data.navType
    this.type = Number(this.$route.query.type)
    this.init()
  },

  methods: {
    async init() {
      const params = {
        subject_id: this.$route.query.subject_id,
      }
      if (this.type === 1) {
        params.type = 1
      }
      this.data = await fetchCourseChapterLists(params)

      this.data.chapter_lists.map((item) => {
        item.percent_num = parseInt(item.percent * 100)
        item.percent_num_text = parseInt(item.percent * 100) + '%'
      })

      this.info.name = this.data.title

      this.$setHtmlTitle(this.info.name)
      this.$nextTick().then(() => {
        const ele = this.$refs.content
        this.isOverLimit = ele.offsetHeight >= 60
      })
    },
    switchContentAll() {
      this.contentAll = !this.contentAll
    },
    goBuy() {
      this.$router.push({
        path: '/order',
        query: { subject_id: this.$route.query.subject_id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  padding-bottom: 0;
  position: relative;
  z-index: 2;
  margin: 0 16px;
  width: calc(100% - 24px);
  top: 30px;
  border-radius: 6px;
  overflow: hidden;
}

.page-bg {
  position: fixed;
  width: 100%;
  height: 130px;
  background-image: url('../assets/images/page-bg.png');
  background-size: 100% 100%;
  z-index: 1;
}

.list {
  position: relative;
  z-index: 2;
  margin: 0 16px;
  width: calc(100% - 24px);
  margin-top: 16px;
  top: 30px;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 2px 6px 1px rgba(210, 210, 210, 0.8);
  padding: 0;
  background: #fff;
  .item {
    margin: 0;
    height: 48px;
    border-bottom: 1px solid #eee;
    .mu-item-wrapper .mu-item .mu-item-title {
      color: #666;
      &:before {
        content: '';
        width: 3px;
        height: 14px;
        background: #2287c2;
        display: inline-block;
        margin-right: 2px;
        position: relative;
        top: 1px;
      }
    }
    .finish {
      color: green;
    }
  }
}

.loader-more-wrapper {
  text-align: center;
  .mu-button {
    vertical-align: top;
  }
}
.content {
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 3; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
}
.content-all {
  -webkit-line-clamp: unset;
  // box-shadow: 6px 12px 54px -13px rgba(0, 0, 0, 0.1);
}
</style>

<style lang="scss">
// 返回章节
.return-chapter {
  display: block;
  width: 45px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  z-index: 9;
}
</style>
